<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Научные специальности и отрасли науки:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat  v-if="!isOnlyRead">
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
              class="elevation-1  "
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{findNameObj('dissertationCouncil',props.item.dissertationCouncil)}}</td>
                <td class="justify-center">{{findNameObj('scientificField',props.item.scientificField)}}</td>
                <td class="justify-center " v-bind="selected" v-if="!isOnlyRead">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Dissertation_council_scientific_field @addItem="addItem"
                              @ended="closedForm"
                              @refreshItem="refreshItem"
                              v-bind="selected"
                              v-bind:info="$route.params.id"
                              v-if="opened_form"
      >
      </Dissertation_council_scientific_field>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import Dissertation_council_scientific_field from "../forms/Dissertation_council_scientific_field"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {isOnlyReadPermission, makeGetRequest} from "../../../../../helper";

    export default {
        name: "ListDissertation_council_scientific_field",
        components: {Dissertation_council_scientific_field},
        mixins: [UserDataMixin],
        props: {
            isDetail: Boolean,
        },
        data: function () {
            return {
                URL_LIST: urls.getUrl('admin|diss|models|dissertation_council_scientific_field-list', 'list')+(this.isDetail ? "?dissertationCouncil=" + this.$route.params.id : ""),
                URL_DELETE: urls.getUrl('admin|diss|models|dissertation_council_scientific_field-detail', 'destroy'),

                selectors:{
                    scientificField:[],
                    dissertationCouncil:[]
                },
                headers: [
                    {
                        text: 'Дис совет', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    },
                    {
                        text: 'Научная специальность', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ],

            }
        },

        methods: {
          isOnlyRead(){
            return isOnlyReadPermission
          },
            findNameObj(edit,id){
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                }else{
                    return ""
                }
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
        },
        created() {

            let url = urls.getUrl('admin|core|selectors|scientific_field', 'get')
            this.loadSelector('scientificField',url)

            url = urls.getUrl('admin|diss|selectors|dissertation_council', 'get')
            this.loadSelector('dissertationCouncil',url)

            this.getItems();
            if (!this.isDetail)
              this.$store.commit('mainpage/changeTitle', 'Научные специальности и отрасли науки');
        },
    }


</script>
<style scoped>

</style>
